import { jsx as _jsx } from "preact/jsx-runtime";
import runLater from '../../../../utils/runLater';
import styles from './QuizTriviaLink.module.scss';
export default function QuizTriviaLink({ onClick }) {
    const onClickHandler = (e) => {
        e.preventDefault();
        onClick();
        // go to original URL
        runLater(() => (window.location.href = 'https://fandom.com/trivia'));
    };
    return (_jsx("a", Object.assign({ className: styles.quizLink, href: "https://fandom.com/trivia", onClick: onClickHandler }, { children: "Check out more quizzes at Fandom Trivia" }), void 0));
}
